import { createPortal } from "react-dom";
import React, { useEffect, useState } from "react";
import { api } from "../../../software/api";
import { toast } from "sonner";
import { CloudRain, X, Loader2 } from "lucide-react";
import { dayLabel, firstName } from "./boardUtils";

export default function RainDayPopup({ tech, date, onClose, onDone }) {
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api("POST", "/board/rain-day", { tech, date }).then(setP).catch((e) => { toast.error(e.message); onClose(); });
  }, [tech, date]); // eslint-disable-line react-hooks/exhaustive-deps
  const go = async () => {
    setBusy(true);
    try {
      const r = await api("POST", "/board/rain-day", { tech, date, confirm: true });
      toast.success(`Moved ${r.moved} job${r.moved === 1 ? "" : "s"} to ${dayLabel(r.to)}`);
      onDone();
    } catch (e) { toast.error(e.message); setBusy(false); }
  };
  return createPortal((
    <div className="fixed inset-0 z-[85] bg-slate-900/60 flex items-center justify-center p-4" onClick={onClose} data-testid="rain-day-popup">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-3 bg-sky-800 text-white">
          <span className="font-display font-black inline-flex items-center gap-2"><CloudRain className="h-5 w-5" />Rain Day</span>
          <button onClick={onClose} data-testid="rain-day-close"><X className="h-5 w-5" /></button>
        </div>
        {!p ? <div className="p-8 text-center text-slate-500"><Loader2 className="h-6 w-6 animate-spin mx-auto" /></div> : (
          <div className="p-4">
            {p.jobs.length === 0 ? (
              <p className="text-sm text-slate-600" data-testid="rain-day-empty">{firstName(tech)} has no jobs on {dayLabel(date)} to move.</p>
            ) : (
              <>
                <p className="font-bold text-slate-900 mb-2" data-testid="rain-day-summary">Move {firstName(tech)}'s {p.jobs.length} job{p.jobs.length === 1 ? "" : "s"} from {dayLabel(p.from)} to {dayLabel(p.to)}?</p>
                <ul className="max-h-56 overflow-y-auto text-[13px] text-slate-700 space-y-1 mb-2">
                  {p.jobs.map((j) => <li key={j.id} className="rounded bg-slate-50 px-2 py-1"><b>{j.client_name || "—"}</b> · {j.text}</li>)}
                </ul>
                <p className="text-[11px] text-slate-500">They'll be added on top of {dayLabel(p.to)}'s jobs — nothing else moves. Each gets “· Rescheduled – rain {date.slice(8)}/{date.slice(5, 7)}” added.</p>
              </>
            )}
          </div>
        )}
        <div className="p-3 border-t border-slate-100 flex gap-2">
          <button onClick={onClose} className="flex-1 rounded-full border-2 border-slate-200 text-sm font-bold py-2">Cancel</button>
          {p?.jobs.length > 0 && <button onClick={go} disabled={busy} data-testid="rain-day-confirm-btn" className="flex-1 rounded-full bg-sky-700 hover:bg-sky-800 text-white text-sm font-bold py-2 disabled:opacity-50">{busy ? "Moving…" : `Move to ${dayLabel(p.to)}`}</button>}
        </div>
      </div>
    </div>
  ), document.body);
}
